import { Inject, Injectable, Optional } from '@angular/core';
import { RosterFeature, SOFTLINE_TOKEN_ROSTER_FEATURE } from '../roster.shared';

@Injectable()
export class RosterFeatureRegistry {
  readonly #featureMap = new Map<string, RosterFeature>();

  constructor(
    @Optional()
    @Inject(SOFTLINE_TOKEN_ROSTER_FEATURE)
    features: RosterFeature[]
  ) {
    for (const feature of features) {
      this.#featureMap.set(feature.name, feature);
    }
  }

  get(featureName: string): RosterFeature | undefined {
    return this.#featureMap.get(featureName);
  }
}
